import styled from 'styled-components';

export interface ArrowIconProps extends React.HTMLAttributes<HTMLDivElement> {
  color?: CSSStyleDeclaration['color'];
  direction?: 'left' | 'right' | 'up' | 'down';
  size?: 'large' | 'medium';
  disabled?: boolean;
}

export const ArrowIcon: React.FC<ArrowIconProps> = ({
  color,
  direction,
  size = 'medium',
  disabled = false,
  ...divAttributes
}) => (
  <S.Container color={color} direction={direction} disabled={disabled} {...divAttributes}>
    <svg
      width={size === 'medium' ? '10px' : '14px'}
      height={size === 'medium' ? '10px' : '14px'}
      viewBox="0 0 10 10"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeMiterlimit="1.5"
    >
      <path d="M0.495,2.506L5.009,7.038L9.529,2.511" fill="none" stroke="black" strokeWidth="1.25px" />
    </svg>
  </S.Container>
);

const S = {
  Container: styled.div<{
    color?: CSSStyleDeclaration['color'];
    direction?: 'left' | 'right' | 'up' | 'down';
    disabled?: boolean;
  }>`
    transition: transform 150ms ease-in-out;
    display: flex;
    justify-content: center;
    align-items: center;

    & path {
      stroke: ${(props) => props.color ?? props.theme.secondary.softBlue3};
    }

    ${({ direction }) => {
      switch (direction) {
        case 'left':
          return `transform: rotate(90deg);`;
        case 'right':
          return `transform: rotate(-90deg);`;
        case 'up':
          return `transform: rotate(180deg);`;
        default:
          return `transform: rotate(0deg);`;
      }
    }}

    ${({ disabled }) => {
      if (!disabled) {
        return '&:hover { cursor: pointer; }';
      }
    }}
  `,
};
